import axios from 'axios';
import apiConfig from '../../api.config';

export default function updateHotelCheckinConfig({ body}) {
  // update ALL hotel checkin config
  const {
    host,
    URIs: { updateHotelCheckinConfig }, 
  } = apiConfig;

  const uri = `${host}${updateHotelCheckinConfig}`;

  return axios
    .put(uri, body, {
    })
    .then(res => {
      return res.data;
    });
}
